function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import classnames from "classnames";
import { MD } from "constants/sizes";
import AssetComponent from "components/core/asset/asset-component";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { titleFontSizeNumber, titleLineHeights } from "segments/desktop/core-components/title/consts";
import { StyledHoverableCards } from "./hoverable-card.scss";
const REM_TO_PX = 16;
const DEFAULT_PARAGRAPH = {
    topic: {}
};
const HoverableCard = (_param)=>{
    var { defaultColor, asset, hoveredAsset, paragraph, hoveredColor, onHover, isSelected, setCardsMaxHeight, textResizeConfig, fullParagraphAdvancedConfig: { selectedTitleSize, titleSize = MD } } = _param, paragraphConfig = _object_without_properties(_param.fullParagraphAdvancedConfig, [
        "selectedTitleSize",
        "titleSize"
    ]);
    const ref = useRef(null);
    const [paragraphHeight, setParagraphHeight] = useState(null);
    const titleSizeInPx = useMemo(()=>titleFontSizeNumber[titleSize] * REM_TO_PX, [
        titleSize
    ]);
    const titleLineHeight = useMemo(()=>{
        var _titleLineHeights_titleSize;
        return (_titleLineHeights_titleSize = titleLineHeights[titleSize]) === null || _titleLineHeights_titleSize === void 0 ? void 0 : _titleLineHeights_titleSize.replace("px", "");
    }, [
        titleSize
    ]);
    const setContentHeights = useCallback(()=>{
        if (!ref.current) return;
        const cardParagraphHeight = ref.current.querySelector(".paragraph-body").getBoundingClientRect().height;
        setParagraphHeight(`${cardParagraphHeight}px`);
        const cardHeight = ref.current.getBoundingClientRect().height;
        setCardsMaxHeight(isSelected ? cardHeight : cardHeight + cardParagraphHeight);
    }, [
        setCardsMaxHeight
    ]);
    useEffect(()=>{
        setContentHeights();
        window.addEventListener("resize", setContentHeights);
        return ()=>window.removeEventListener("resize", setContentHeights);
    }, [
        setContentHeights
    ]);
    return /*#__PURE__*/ _jsxs(StyledHoverableCards, {
        ref: ref,
        textResizeConfig: textResizeConfig,
        titleSize: titleSizeInPx,
        defaultColor: defaultColor,
        onMouseEnter: onHover,
        titleLineHeight: titleLineHeight,
        hoveredColor: hoveredColor,
        paragraphHeight: paragraphHeight,
        className: classnames("hoverable-card", {
            selected: isSelected
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "asset-container",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "default-asset",
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({
                            onImageLoad: setContentHeights
                        }, asset))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "selected-asset",
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, hoveredAsset))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, DEFAULT_PARAGRAPH, paragraph, paragraphConfig), {
                titleSize: selectedTitleSize,
                titleClassName: "card-title"
            }))
        ]
    });
};
export default HoverableCard;
